<template>
    <div id="ispprove">
        <div class="item">
            <img class="item-img" @click="previewImg('//acdn.mulazim.com/company_info/icpzheng.png')"
                src="//acdn.mulazim.com/company_info/icpzheng.png" />
        </div>
    </div>
</template>
<script>
export default {
    name: "ispprove",
    methods: {
        previewImg(urls) {
            this.$hevueImgPreview({ name: urls, url: urls });
        },
    },
};
</script>
  
<style scoped>
* {
    margin: 0;
    padding: 0;
}

#app {
    background: #f2f2f2;
}

.item {
    height: 100%;
    width: 100%;
}

.item-img {
    width: 100%;
    height: 100%;
}
</style>
  